// SMART DEMO — Mavi Nokta Hizmet asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 on-site + 4 appointment-service + 4 technical-service + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Mavi Nokta Hizmet" tamamen kurgu demo markadır.

export const MAVI_NOKTA_ASSET_ROOT = "/demo-presets/other/mavi-nokta";

export interface MaviNoktaManifest {
  logo: string;
  onSite: string[];
  appointmentService: string[];
  technicalService: string[];
  videos: string[];
}

export const MAVI_NOKTA_MANIFEST: MaviNoktaManifest = {
  logo: `${MAVI_NOKTA_ASSET_ROOT}/logo/logo.webp`,
  onSite: [
    `${MAVI_NOKTA_ASSET_ROOT}/on-site/01.webp`,
    `${MAVI_NOKTA_ASSET_ROOT}/on-site/02.webp`,
    `${MAVI_NOKTA_ASSET_ROOT}/on-site/03.webp`,
    `${MAVI_NOKTA_ASSET_ROOT}/on-site/04.webp`,
  ],
  appointmentService: [
    `${MAVI_NOKTA_ASSET_ROOT}/appointment-service/01.webp`,
    `${MAVI_NOKTA_ASSET_ROOT}/appointment-service/02.webp`,
    `${MAVI_NOKTA_ASSET_ROOT}/appointment-service/03.webp`,
    `${MAVI_NOKTA_ASSET_ROOT}/appointment-service/04.webp`,
  ],
  technicalService: [
    `${MAVI_NOKTA_ASSET_ROOT}/technical-service/01.webp`,
    `${MAVI_NOKTA_ASSET_ROOT}/technical-service/02.webp`,
    `${MAVI_NOKTA_ASSET_ROOT}/technical-service/03.webp`,
    `${MAVI_NOKTA_ASSET_ROOT}/technical-service/04.webp`,
  ],
  videos: [
    `${MAVI_NOKTA_ASSET_ROOT}/videos/01.mp4`,
    `${MAVI_NOKTA_ASSET_ROOT}/videos/02.mp4`,
  ],
};